import { postMethodWithUpload } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const ADD_CONTRACT_FILE = 'ADD_CONTRACT_FILE';
export const ADD_CONTRACT_FILE_SUCCESS = 'ADD_CONTRACT_FILE_SUCCESS';
export const ADD_CONTRACT_FILE_FAILURE = 'ADD_CONTRACT_FILE_FAILURE';

// Action Creators
export const addContractFileRequest = () => ({
  type: ADD_CONTRACT_FILE,
});

export const addContractFileSuccess = (users) => ({
  type: ADD_CONTRACT_FILE_SUCCESS,
  payload: users,
});

export const addContractFileFailure = (error) => ({
  type: ADD_CONTRACT_FILE_FAILURE,
  payload: error,
});

// Thunk Function
export const addContractFileCallAPI = (body, external) => {
  return async (dispatch) => {
    dispatch(addContractFileRequest());
    try {
      const response = await postMethodWithUpload(url.doctorContract, body);
      dispatch(addContractFileSuccess(response));
      if (external?.run === true) {
        if (
          response?.data?.status_code === 200 ||
          response?.data?.status_code === 201
        ) {
          external?.handleFunction(response?.data);
        } else {
          if (external?.error === true) {
            external?.handleErrorFunction(response?.data);
          }
        }
      }
    } catch (error) {
      dispatch(addContractFileFailure(error?.message));
      if (external?.error === true) {
        external?.handleErrorFunction(error);
      }
    }
  };
};
